export default "/assets/images/mila-feed-15-thumbnail.jpg?40023f6462a6800bd210cf3cb975848f";